import { render } from "./paginacaoLista.vue?vue&type=template&id=e95e6990&scoped=true&ts=true"
import script from "./paginacaoLista.vue?vue&type=script&lang=ts"
export * from "./paginacaoLista.vue?vue&type=script&lang=ts"

import "./paginacaoLista.vue?vue&type=style&index=0&id=e95e6990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95e6990"]])

export default __exports__